import { render, staticRenderFns } from "./MbTitle.vue?vue&type=template&id=28abc54c&scoped=true&"
import script from "./MbTitle.vue?vue&type=script&lang=js&"
export * from "./MbTitle.vue?vue&type=script&lang=js&"
import style0 from "./MbTitle.vue?vue&type=style&index=0&id=28abc54c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28abc54c",
  null
  
)

export default component.exports